import { MimeType } from './mime-type';

export const IMAGE_BY_MIME_TYPE: Partial<Record<MimeType, string>> = {
    [MimeType.ApplicationIllustrator]: '/file-types/thumbnail-ai.svg',
    [MimeType.ApplicationMsWord]: '/file-types/thumbnail-doc.svg',
    [MimeType.ApplicationOctetStream]: '/file-types/thumbnail-other.svg',
    [MimeType.ApplicationPdf]: '/file-types/thumbnail-pdf.svg',
    [MimeType.ApplicationPostscript]: '/file-types/thumbnail-eps.svg',
    [MimeType.ApplicationVndMsExcel]: '/file-types/thumbnail-xls.svg',
    [MimeType.ApplicationVndMsPowerpoint]: '/file-types/thumbnail-ppt.svg',
    [MimeType.ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation]: '/file-types/thumbnail-ppt.svg',
    [MimeType.ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet]: '/file-types/thumbnail-xls.svg',
    [MimeType.ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument]: '/file-types/thumbnail-doc.svg',
    [MimeType.ApplicationZip]: '/file-types/thumbnail-zip.svg',
    [MimeType.AudioMp3]: '/file-types/thumbnail-mp3.svg',
    [MimeType.AudioMpeg3]: '/file-types/thumbnail-mp3.svg',
    [MimeType.AudioWav]: '/file-types/thumbnail-wav.svg',
    [MimeType.ImageGif]: '/file-types/thumbnail-gif.svg',
    [MimeType.ImageJpeg]: '/file-types/thumbnail-jpg.svg',
    [MimeType.ImagePng]: '/file-types/thumbnail-png.svg',
    [MimeType.ImageVndAdobePhotoshop]: '/file-types/thumbnail-psd.svg',
    [MimeType.TextCsv]: '/file-types/thumbnail-csv.svg',
    [MimeType.TextHtml]: '/file-types/thumbnail-html.svg',
    [MimeType.TextPlain]: '/file-types/thumbnail-txt.svg',
    [MimeType.VideoAvi]: '/file-types/thumbnail-avi.svg',
    [MimeType.VideoMp4]: '/file-types/thumbnail-avi.svg',
    [MimeType.VideoQuicktime]: '/file-types/thumbnail-avi.svg',
    [MimeType.VideoWma]: '/file-types/thumbnail-avi.svg',
    [MimeType.VideoWmv]: '/file-types/thumbnail-avi.svg',
};
